import { render } from "./mobile-money-tanzania.vue?vue&type=template&id=a7c8bbfe"
import script from "./mobile-money-tanzania.vue?vue&type=script&lang=js"
export * from "./mobile-money-tanzania.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__